import { useState } from 'react';
import { TelehealthButton, type TelehealthButtonType } from './telehealth-button';
import { TelehealthRequestStepsModal } from './telehealth-request-steps-modal';

type P = {
  buttonType: TelehealthButtonType;
};

const TelehealthRequest = ({ buttonType }: P) => {
  const [isTelehealthRequestModalOpened, setIsTelehealthRequestModalOpened] = useState(false);

  return (
    <>
      <TelehealthButton
        buttonType={buttonType}
        onClick={() => {
          setIsTelehealthRequestModalOpened(true);
        }}
      >
        Request telehealth visit
      </TelehealthButton>

      <TelehealthRequestStepsModal
        isOpened={isTelehealthRequestModalOpened}
        onClose={() => {
          setIsTelehealthRequestModalOpened(false);
        }}
      />
    </>
  );
};

export default TelehealthRequest;
